import styled from 'styled-components'
import { theme } from '../../theme/theme'
import { Dots } from '../icons/Dots'
import { Title6, BodySmall } from '../styles/Typography'
import { ToggleButton } from './ToggleButton'
import {
  useSelectIsAdmin,
  useSelectUserFullName,
  useSelectUserInviterName,
  useSelectUserOrganisationName,
} from '../../state/selectors'

import { MenuDropdown } from '../MenuDropdown'
import { useLogout } from '../../hooks/useLogout'
import { useNavigate } from 'react-router-dom'
import { useDeleteScreening } from '../../api/ester-b2b-api/private/screening/screeningQueries'
import { env } from '../../utils/environments/environmentVariables'
import { useTranslation } from 'react-i18next'
import { dataPolicyPath } from '../../views/policy/dataPolicyPath'

export const SidebarUserMenu = () => {
  const { t, i18n } = useTranslation()
  const userFullName = useSelectUserFullName()
  const organisation = useSelectUserOrganisationName()
  const invitedName = useSelectUserInviterName()
  const isAdmin = useSelectIsAdmin()
  const logout = useLogout()
  const navigate = useNavigate()
  const deleteScreeningMutation = useDeleteScreening()
  const organisationName = invitedName ? `${t('common.menu.esterInvite')} ${invitedName}` : organisation

  const handleDeleteScreening = () => {
    deleteScreeningMutation.mutate(undefined, {
      onSuccess: () => {
        alert(t('common.alerts.screeningCleared'))
      },
    })
  }

  const menuItems = [
    {
      label: t('common.navigation.myAccount'),
      onClick: () => {
        navigate('/profile')
      },
    },
    {
      label: t('common.dataPolicy.menuLink'),
      onClick: () => {
        window.open(dataPolicyPath(i18n.language), '_blank', 'noopener,noreferrer')
      },
    },
  ]

  if (!env.isProd('VITE_NODE_ENV')) {
    menuItems.push({
      label: t('common.menu.clearScreening'),
      onClick: handleDeleteScreening,
    })
  }

  menuItems.push({
    label: t('common.navigation.logout'),
    onClick: logout,
  })

  return (
    <BottomContainer>
      <AccountContainer>
        <div>
          <StyledTitle6>{userFullName}</StyledTitle6>
          <BodySmall>{organisationName}</BodySmall>
        </div>

        <MenuDropdown
          anchorOrigin={{
            vertical: -20,
            horizontal: 140,
          }}
          menuItems={menuItems}
        >
          <ThreeDotsWithHoover>
            <Dots size={26} />
          </ThreeDotsWithHoover>
        </MenuDropdown>
      </AccountContainer>
      {isAdmin && <ToggleButton />}
    </BottomContainer>
  )
}

const StyledTitle6 = styled(Title6)`
  white-space: normal;
  word-break: break-word;
`
const BottomContainer = styled.div`
  border-top: 1px ${theme.color.grey2} solid;
  padding: ${theme.spacing.mediumLarge}px ${theme.spacing.mediumLarge}px ${theme.spacing.medium}px;
`

const AccountContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

const ThreeDotsWithHoover = styled.button`
  margin-left: 8px;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.6s;
  border: none;
  background-color: ${theme.color.beigeLight};

  &:hover {
    background-color: ${theme.color.beigeDark};
  }
`
